import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import FilmNewsPage from "@/pages/category/filmNews/page";
import EntertainmentNewsPage from "@/pages/category/entertainmentNews/page";
import MovieRecommendPage from "@/pages/category/movieRecommend/page";
import TvUpdatePage from "@/pages/category/tvUpdate/page";
import DetailPage from "@/pages/detail/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/film-news",
    element: <FilmNewsPage />,
  },
  {
    path: "/category/entertainment-news",
    element: <EntertainmentNewsPage />,
  },
  {
    path: "/category/movie-recommend",
    element: <MovieRecommendPage />,
  },
  {
    path: "/category/tv-update",
    element: <TvUpdatePage />,
  },
  {
    path: "/detail/:id",
    element: <DetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;